<div class="shift-summary" (mouseenter)="onMouseOver()" (mouseleave)="onMouseOut()">
  <sl-label size="x-small" color="dark">
    <span *ngIf="!showDetails"><span i18n="@@shiftSummary.stops">{totalStops, plural, =1 {{{totalStops}} stop} other {{{totalStops}} stops}}</span> ({{totalDuration | duration }} / {{totalDistance / 1000 | number:'1.0-1'}}km)</span>
    <span *ngIf="showDetails">{{distanceOut / 1000 | number:'1.0-1'}}km / {{distanceBetween / 1000 | number:'1.0-1'}}km / {{distanceHome / 1000 | number:'1.0-1'}}km</span>
  </sl-label>
  <sl-label size="x-small" color="dark">
    <span *ngIf="!showDetails">{{totalAmount / 100 | currency:currency}}</span>
    <span *ngIf="showDetails" i18n>{{(totalAmount - totalAmountCompleted) / 100 | currency:currency}} left</span>
  </sl-label>
</div>
